import { P2GBox } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GLinkGroup } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';

import AlertWithIcon from '../../../AlertWithIcon';

export interface props {
  reset: () => void;
  cancel: () => void;
}

export const MultiConsignmentUnsupported: React.FC<props> = (props) => {
  return (
    <P2GBox mb={2}>
      <AlertWithIcon color="error">
        <P2GText variant="body2">
          <strong>Note:</strong> This service does not support muti-parcel shipments.
          <br />
          You can send as a single-parcel shipment, or click 'Close' if you want to choose a different service.
        </P2GText>
        <P2GLinkGroup
          pt={1}
          links={[
            <P2GLink onClick={props.reset}>Send as Single Parcel</P2GLink>,
            <P2GLink onClick={props.cancel}>Close</P2GLink>
          ]}
        />
      </AlertWithIcon>
    </P2GBox>
  );
};
